import type { ITableWrapper } from "libs/design-system/src/types/table/table_wrapper";
import styles from "./table-wrapper.module.scss";

export const TableWrapper = ({ children, disabled, wrapperClassName }: ITableWrapper) => {
  return (
    <div
      className={`${styles["table-wrapper"]} ${wrapperClassName || ""}`}
      data-table-wrapper-disabled={disabled}
    >
      {children}
    </div>
  )
}